import { render, staticRenderFns } from "./ChooseOptionButton.vue?vue&type=template&id=08d2da90&scoped=true&"
import script from "./ChooseOptionButton.vue?vue&type=script&lang=js&"
export * from "./ChooseOptionButton.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOptionButton.vue?vue&type=style&index=0&id=08d2da90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d2da90",
  null
  
)

export default component.exports